import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=d8e3d110&"
import script from "./RegionList.vue?vue&type=script&lang=js&"
export * from "./RegionList.vue?vue&type=script&lang=js&"
import style0 from "./RegionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports